module.exports = __webpack_public_path__ + "media/images/services-left-image-01d716259c0acf978d3e197cb4a13c34.png";